<ng-container *ngFor="let reportLogEvent of reportLogOfEvents">
  <app-report-events-log-with-activity-groups
    *ngIf="enableEventsLogActivityGroupsOnly; else withActivities"
    [reportLogOfEvent]="reportLogEvent"
    [eventLogPrefix]="eventLogPrefix"
  ></app-report-events-log-with-activity-groups>

  <ng-template #withActivities>
    <app-report-events-log-with-groups-and-activities
      [reportLogOfEvent]="reportLogEvent"
      [eventLogPrefix]="eventLogPrefix"
    ></app-report-events-log-with-groups-and-activities>
  </ng-template>
</ng-container>
